import styled, { css } from 'styled-components';
import { mediaQuery } from 'styles/helper';

export const HeadContainer = styled.thead``;

export const HeadRow = styled.tr`
  display: grid;

  ${mediaQuery(
    'md',
    css`
      grid-template-columns: unset;
      display: flex;
      width: 100%;
    `
  )}
`;
